import { render, staticRenderFns } from "./MvAmount.vue?vue&type=template&id=ce7f13d4&"
import script from "./MvAmount.vue?vue&type=script&lang=js&"
export * from "./MvAmount.vue?vue&type=script&lang=js&"
import style0 from "./MvAmount.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports